const themeReducer = (state, action) => {
  switch (action.type) {
    case 'SET_THEME': {
      localStorage.setItem('rfs:theme', action.payload);
      return action.payload;
    }
    default:
      return state;
  }
};

const languageReducer = (state, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE': {
      localStorage.setItem('rfs:language', action.payload);
      return action.payload;
    }
    default:
      return state;
  }
};

export default function settingsReducer(state, action) {
  const { theme, language } = state;

  return {
    theme: themeReducer(theme, action),
    language: languageReducer(language, action),
  };
}
